import { render, staticRenderFns } from "./validations-tooltip.vue?vue&type=template&id=6508a34c&scoped=true&"
import script from "./validations-tooltip.vue?vue&type=script&lang=js&"
export * from "./validations-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./validations-tooltip.vue?vue&type=style&index=0&id=6508a34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508a34c",
  null
  
)

export default component.exports